const projects = [
	{
		id: 1,
		title: 'ISUE-ORANGE',
		category: 'Web Application',
		description:
			'ISUE ORANGE or "Isabela State University Online Resources App for a New Guild of Education" is a full blown Learning Mangement System for the Isabela State University Echague Campus hosted on Digital Ocean.',
		date: 'November 2021',
		techs: [
			'HTML',
			'CSS',
			'JavaScript',
			'Vue.js',
			'Vuetify.js',
			'Laravel',
			'MySql',
			'Linux',
			'Nginx',
			'Firebase',
			'Websocket',
			'Cloud Storage'
		],
		companyInfos: [
			{
				id: 1,
				title: 'Services',
				details: 'WEB DEVELOPMENT'
			},
			{
				id: 2,
				title: 'Website URL',
				details: 'https://isu-orange.com/'
			}
		],
		objective: 'To developed and deploy a learning management system which will be used by college and eventually absorb by a university',
		img: require('@/assets/images/projects/isu-orange.png')
	},
	{
		id: 2,
		title: 'E-CAPS',
		category: 'Web Application',
		description:
			'E-CAPS is A Lan based Electronic Capstone Project Finder created this during my Intern deployed on Apache WAMP Server.',
		date: 'March 2022',
		techs: [ 'HTML', 'CSS', 'JavaScript', 'Vue.js', 'Vuetify.js', 'Laravel', 'MySql', 'Linux', 'WAMP' ],
		companyInfos: [
			{
				id: 1,
				title: 'Services',
				details: 'WEB DEVELOPMENT'
			},
			{
				id: 2,
				title: 'Website URL',
				details: 'N/A'
			}
		],
		objective: 'To developed a simple library system which will contain list of different capstone projects that has been approved to eliminate duplication on capstone titles',
		img: require('@/assets/images/projects/e-caps2.png')
	},
	{
		id: 4,
		title: 'GEEKNIGH LMS',
		category: 'Web Application',
		techs: [ 'HTML', 'CSS', 'JavaScript', 'Bootstrap', 'PHP', 'MySql' ],
		description:
			'Geeknight is a learning management system that allows teachers to create their own courses, invite students to join, cuztomize their grading system, create quizzes,assignments,exam and etc. Geeknight was inspired on Google Classroom and Edmodo Features.',
		date: 'November 2019',
		companyInfos: [
			{
				id: 1,
				title: 'Services',
				details: 'WEB DEVELOPMENT'
			},
			{
				id: 2,
				title: 'Website URL',
				details: 'N/A'
			}
		],
		objective: '',
		img: require('@/assets/images/projects/geeknight.png')
	},
	{
		id: 5,
		title: 'BARANGAY HEALTH RECORD MONITORING SYSTEM WITH SMS',
		category: 'Web Application',
		description:
			'BARANGAY HEALTH RECORD MONITORING SYSTEM WITH SMS is Laravel and vue project with sms using vonage api',
		date: 'DECEMBER 2022',
		techs: [ 'HTML', 'CSS', 'JavaScript', 'Vue.js', 'Vuetify.js', 'Laravel', 'MySql', 'Linux' ],
		companyInfos: [
			{
				id: 1,
				title: 'Services',
				details: 'WEB DEVELOPMENT'
			},
			{
				id: 2,
				title: 'Website URL',
				details: 'http://bgry-suerte-health-center.online/login'
			}
		],
		objective: 'To developed a record monitoring system with sms notification for a small barangay',
		img: require('@/assets/images/projects/bgry_system.png')
	},
	{
		id: 6,
		title: 'E-COMMERCE',
		category: 'Web Application',
		description:
			'A hybrid e-commerce website build using Laravel I recently developed this alone of previous work as full stack developer. It you want to visit the website here the link  https://mekanikart.ph/',
		date: 'FEBRUARY 2023',
		techs: [ 'HTML', 'CSS', 'JavaScript', 'Laravel', 'MySql', 'Linux', 'Docker' ],
		companyInfos: [
			{
				id: 1,
				title: 'Services',
				details: 'WEB DEVELOPMENT'
			},
			{
				id: 2,
				title: 'Website URL',
				details: 'Confindential'
			}
		],
		objective: 'To developed a hybrid e-commerece website for a souvenir store',
		img: require('@/assets/images/projects/e-commerce.png')
	}
];

export default projects;
